module.exports = __webpack_public_path__ + "img/the-taming-of-the-queen.c1d0534f.png";